import { useQuery } from "@tanstack/react-query";
import api from "apis";

export const useDocumentCategories = () => {
  return useQuery({
    queryKey: api.document.getDocumentCategoriesKey(),
    queryFn: () => api.document.getDocumentCategories(),
    select: (data) => data.data.result,
  });
};
